/* eslint-disable */
import { Http } from '../library';
import { httpMethods } from '../enums';
import * as Endpoints from '../constants/endpoints.constant';
import api from '../api/client';

class BuySellService {
  /**
   * Add new quotation
   * @param data
   */
  async addQuote(data, userId, signal) {
    const newdata = { ...data, user_id: userId };
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.QUOTE)
      .setSignal(signal)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Buy metal with UPI
   * @param data
   */
  async buyWithUPI(data) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.BUY_WITH_UPI)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Verify UPI payment
   * @param data
   */
  async verifyUPIPaymentRazorpay(data) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.VERIFY_WITH_UPI_RAZORPAY)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Buy metal with net banking
   * @param data
   */
  async buyWithNEBK(data) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.BUY_WITH_NET_BANKING)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Verify net banking payment
   * @param data
   */
  async verifyNEBKPaymentRazorpay(data) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.VERIFY_WITH_NET_BANKING_RAZORPAY)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Place a new order
   * @param data
   */
  async placeOrder(data, signal, userId) {
    const newData = { ...data,user_id: userId };
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.ORDER)
      .setSignal(signal)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  }
  /**
   * Check Payment Status
   * @param data
   */
  async checkPaymentStatus(data, signal) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.GET_PAYMENT_STATUS)
      .setSignal(signal)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }
  /**
   * Create Default Account
   * @param data
   */
  async createDefaultAccount(data) {
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(Endpoints.DEFAULT_ACC)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Download order summary pdf
   * @param id
   * @returns
   */
  async downloadOrderSummary(id, userId) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.ORDER_SUMMARY_PDF}/${id}?user_id=${userId}`)
      // .setResponseType('blob')
      .setToken(api.getToken())
      .request();
  }

  /**
   * Download invoice pdf
   * @param id
   * @returns
   */
  async downloadInvoice(id, userId) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.INVOICE_PDF}/${id}?user_id=${userId}`)
      // .setResponseType('blob')
      .setToken(api.getToken())
      .request();
  }

  /**
   * Verify OTP
   * @param data
   */
  async verifyOTP(data, userId) {
    const newData = { ...data,user_id: userId };
    return await Http.setMethod(httpMethods.patch)
      .unsetData()
      .setUrl(Endpoints.VERIFY_OTP_BUYBACK)
      .setData(newData)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Resend OTP
   * @param data
   */
  async resendOTP(data) {
    return await Http.setMethod(httpMethods.patch)
      .unsetData()
      .setUrl(Endpoints.RESEND_OTP)
      .setData(data)
      .setToken(api.getToken())
      .request();
  }

  /**
   * Generate buy-sell transaction OTP
   * @param mobile
   */
  async generateOtp(mobile, ruleType, otpId, userId) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${
          Endpoints.GENERATE_TRANSACTION_OTP
        }?mobile=${mobile}&user_id=${userId}&ruleType=${ruleType}${
          otpId ? `&otpId=${otpId}` : ''
        }`
      )
      .setToken(api.getToken())
      .request();
  }
  /**
   * Check 24hr lockin
   * @param quoteReferenceId
   */
  async checkLockinPeriod(quoteReferenceId) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.LOCKIN_CHECK}/${quoteReferenceId}`)
      .setToken(api.getToken())
      .request();
  }
  /**
   * Upload document
   */
  async uploadDocument(data,userId:any) {
    const newdata = {...data,user_id:userId}
    return await Http.setMethod(httpMethods.post)
      .unsetData()
      .setUrl(`${Endpoints.UPLOAD_BOARD_RESOLUTION}`)
      .setData(newdata)
      .setToken(api.getToken())
      .request();
  }
  /**
   * Upload document
   */
  async getSignedDocument(companyId, userId: any) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.UPLOAD_BOARD_RESOLUTION}/${companyId}?user_id=${userId}`)
      .setToken(api.getToken())
      .request();
  }

  // new code for get coupon
  async getCouponList(companyId, metal, amoutData) {
    return await Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(
        `${Endpoints.GET_COUPON_LIST}/${companyId}?metal=${metal}&orderAmount=${amoutData.requestedValueAmount}&orderMetalQuantity=${amoutData.requestedValueQuantity}`
      )
      .setToken(api.getToken())
      .request();
  }
}

export default new BuySellService();
